// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__tV4uN","col":"styles_col__3tAVI","fulfillmentStatus":"styles_fulfillmentStatus__Jdq_F","emailCol":"styles_emailCol__24Bic"};